import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {BaseModalComponent} from "../../../base-modal/base-modal.component";
import {AddTelegramAccountFormField} from "../../types/add-telegram-account-form.types";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {PhoneMaskDirective} from "../../../../../../shared/directives/phone-mask.directive";

@Component({
  selector: 'app-add-telegram-account-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    PhoneMaskDirective,
    MatInput
  ],
  templateUrl: './add-telegram-account-form.component.html',
  styleUrl: './add-telegram-account-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddTelegramAccountFormComponent extends BaseModalComponent {
  formGroup = input<FormGroup>(new FormGroup({}));
  currentStep = input<number>(0);
  formFields = input<Array<AddTelegramAccountFormField>>([]);

  public isDisabled(disabled?: boolean): boolean {
    return !!(this.currentStep() === 2 || disabled);
  }
}
